import { InjectionToken } from '@angular/core';
import { NotificationItem } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state';

export const CONSTRUCTION_LOG_PAGINATOR = new InjectionToken('CONSTRUCTION_LOG_PAGINATOR', {
  factory: () => new PagedCollection<NotificationItem>(),
  providedIn: 'root',
});
